import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import Switch from 'flarum/common/components/Switch';
import Stream from 'flarum/common/utils/Stream';
export default class StickyModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "isSticky", void 0);
    _defineProperty(this, "isStickiest", void 0);
    _defineProperty(this, "isTagSticky", void 0);
    _defineProperty(this, "selectedTagIds", void 0);
  }
  oninit(vnode) {
    var _discussion$isSticky;
    super.oninit(vnode);
    const discussion = this.attrs.discussion;

    // canSticky() flarum/sticky yoksa undefined döner
    this.isSticky = Stream(((_discussion$isSticky = discussion.isSticky) == null ? void 0 : _discussion$isSticky.call(discussion)) || false);
    this.isStickiest = Stream(discussion.isStickiest() || false);
    this.isTagSticky = Stream(discussion.isTagSticky() || false);
    const stickyTagIds = discussion.attribute('stickyTagIds') || [];
    this.selectedTagIds = Stream(stickyTagIds);
  }
  className() {
    return 'StickyModal Modal--small';
  }
  title() {
    const discussionTitle = this.attrs.discussion.title();
    return app.translator.trans('huseyinfiliz-stickiest.forum.sticky_modal.title', {
      title: m('em', {}, discussionTitle)
    });
  }
  content() {
    var _tags, _ref, _discussion$canSticky;
    const discussion = this.attrs.discussion;
    const discussionTags = ((_tags = (_ref = discussion).tags) == null ? void 0 : _tags.call(_ref)) || [];

    // flarum/sticky yüklü mü kontrol et
    const hasStickyExtension = typeof discussion.canSticky === 'function';
    const items = [];

    // Normal Sticky - sadece flarum/sticky yüklüyse göster
    if (hasStickyExtension && (_discussion$canSticky = discussion.canSticky) != null && _discussion$canSticky.call(discussion)) {
      items.push(m('.Form-group', {}, [m(Switch, {
        state: this.isSticky(),
        onchange: value => {
          this.isSticky(value);
          if (value) {
            this.isStickiest(false);
            this.isTagSticky(false);
          }
        }
      }, app.translator.trans('huseyinfiliz-stickiest.forum.sticky_modal.sticky_label')), m('p.helpText', {}, app.translator.trans('huseyinfiliz-stickiest.forum.sticky_modal.sticky_help'))]));
    }

    // Super Sticky
    if (discussion.canStickiest()) {
      items.push(m('.Form-group', {}, [m(Switch, {
        state: this.isStickiest(),
        onchange: value => {
          this.isStickiest(value);
          if (value) {
            this.isSticky(false);
          }
        }
      }, app.translator.trans('huseyinfiliz-stickiest.forum.sticky_modal.stickiest_label')), m('p.helpText', {}, app.translator.trans('huseyinfiliz-stickiest.forum.sticky_modal.stickiest_help'))]));
    }

    // Tag Sticky
    if (discussion.canTagSticky()) {
      items.push(m('.Form-group', {}, [m(Switch, {
        state: this.isTagSticky(),
        onchange: value => {
          this.isTagSticky(value);
          if (value) {
            this.isSticky(false);
          }
        }
      }, app.translator.trans('huseyinfiliz-stickiest.forum.sticky_modal.tag_sticky_label')), m('p.helpText', {}, app.translator.trans('huseyinfiliz-stickiest.forum.sticky_modal.tag_sticky_help'))]));
    }

    // Tag Seçimi
    if (discussion.canTagSticky() && this.isTagSticky() && discussionTags.length > 0) {
      const tagCheckboxes = discussionTags.map(tag => {
        const tagId = Number(tag.id());
        return m('label.checkbox', {}, [m('input[type=checkbox]', {
          checked: this.selectedTagIds().includes(tagId),
          onchange: e => {
            const target = e.target;
            let ids = [...this.selectedTagIds()];
            if (target.checked) {
              if (!ids.includes(tagId)) {
                ids.push(tagId);
              }
            } else {
              ids = ids.filter(id => id !== tagId);
            }
            this.selectedTagIds(ids);
          }
        }), m('span.TagLabel', {
          style: {
            backgroundColor: tag.color() || '#888'
          }
        }, tag.name())]);
      });
      items.push(m('.Form-group', {}, [m('label', {}, app.translator.trans('huseyinfiliz-stickiest.forum.sticky_modal.select_tags')), m('.StickyModal-tags', {}, tagCheckboxes)]));
    }

    // Submit Button
    items.push(m('.Form-group', {}, m(Button, {
      type: 'submit',
      className: 'Button Button--primary',
      loading: this.loading
    }, app.translator.trans('huseyinfiliz-stickiest.forum.sticky_modal.submit_button'))));
    return m('.Modal-body', {}, m('.Form', {}, items));
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    const discussion = this.attrs.discussion;
    const hasStickyExtension = typeof discussion.canSticky === 'function';
    const data = {
      isStickiest: this.isStickiest(),
      isTagSticky: this.isTagSticky(),
      stickyTagIds: this.isTagSticky() ? this.selectedTagIds() : []
    };

    // Sadece flarum/sticky yüklüyse isSticky gönder
    if (hasStickyExtension) {
      data.isSticky = this.isSticky() && !this.isStickiest() && !this.isTagSticky();
    }
    this.attrs.discussion.save(data).then(() => {
      this.hide();
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('huseyinfiliz-stickiest', 'forum/components/StickyModal', StickyModal);